<!--

	A notification to let users know about tutorial videos after log in for the first time

-->
<template>
	<div>
		<div>
			<Message :toast="toast" :portal="getPortalId()">
				<span v-tr="'introduction_tutorial_videos'" />
			</Message>
			<Button :toast="toast" :portal="getPortalId('close')">
				<span v-tr="'introduction_tutorial_video.popup_close'" />
			</Button>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import { type SnotifyToast, type SnotifyToastConfig } from "vue3-snotify";
import { MiaPlaza } from "../../../Reinforced.Typings";
import Button from "./Shared/Button.vue";
import Message from "./Shared/Message.vue";
import { SNotification } from "./Shared/SNotification";

@Component({
	components: {
		Button,
		Message,
	},
})
export class IntroductionTutorialVideos extends SNotification<MiaPlaza.Control.Vue.Notifications.IIntroductionTutorialVideos> {
	protected getToastConstructor(): (config: SnotifyToastConfig) => SnotifyToast {
		return (config) => { return this.$snotify.info("…", config); };
	}

	protected getToastConfig(): SnotifyToastConfig {
		return {
			...this.getDefaultToastConfig(),
			closeOnClick: false,
			buttons: [
				{
					action: () => this.dismissOnServer().then(() => this.hide()),
					text: this.getPortalId("close"),
				},
			],
		};
	}
}

export default toNative(IntroductionTutorialVideos);
</script>
